module.exports = __webpack_public_path__ + "img/404.50e7118a.png";